<div class="page">

  <div class="pagehead">
    <div>
      <h1>Download earnings report</h1>
      <p>Pick a service and date range — the report downloads as an Excel file</p>
    </div>
  </div>

  <div class="card form-card">
    <div class="clabel"><svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>Report filters</div>
    <div class="kit-form">
      <div class="form-grid">
        <div class="er-field">
          <label class="er-field__label" for="ex-service">Service</label>
          <select id="ex-service" class="er-select" [(ngModel)]="service">
            <option value="" disabled selected hidden>All or a specific service</option>
            <option *ngFor="let service of services" [value]="service.value">{{ service.serviceName }}</option>
          </select>
        </div>

        <div class="dates">
          <div class="er-field date-field">
            <label class="er-field__label">From</label>
            <mat-form-field appearance="outline" class="date-mat">
              <input matInput [matDatepicker]="picker1" placeholder="Choose a date" [(ngModel)]="start">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="er-field date-field">
            <label class="er-field__label">To</label>
            <mat-form-field appearance="outline" class="date-mat">
              <input matInput [matDatepicker]="picker2" placeholder="Choose a date" [(ngModel)]="end">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="er-btn er-btn--ghost" (click)="OpenList()">Back</button>
        <button type="button" class="er-btn er-btn--primary" (click)="searchByDateRange()">
          <i class="fa fa-download" aria-hidden="true"></i>&nbsp;Download excel
        </button>
      </div>
    </div>
  </div>

</div>
